import { LoadingSpinner } from '../LoadingSpinner';

export interface FullPageLoaderProps {
  message?: string;
  spinnerColor?: string;
}

const FullPageLoader: React.FC<FullPageLoaderProps> = ({
  message,
  spinnerColor = 'border-primary-yellow',
}) => {
  return (
    <div className="fixed inset-0 z-101 flex items-center justify-center bg-primary-white/85">
      <div className="flex flex-col items-center gap-1-6">
        <LoadingSpinner size="large" color={spinnerColor} />
        {message ? (
          <span className="text-primary-black text-body1 font-md text-center">
            {message}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default FullPageLoader;
